// extracted by mini-css-extract-plugin
export var fadeInOut = "_18-3";
export var icon = "_18-4";
export var savedIndicator = "_18-2";
export var savingIndicator = "_18-0";
export var spin = "_18-1";